<span class="disabled-text">
    <ng-content></ng-content>
</span>